import React from "react";
import QuotationCardComponent from "./quotation-card.component";
import { IQuotationCard } from "./types";

const QuotationCardContainer = (props: IQuotationCard) => {
  return <QuotationCardComponent {...props} />;
};

export default QuotationCardContainer;
